// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import * as _ from 'lodash';
import { IClaimActionData, claimActionData } from 'src/app/features/claim-action/models/claim-action-data';
import { isEmptyObject } from 'src/app/infrastructure/functions/is-empty-object.function';
import { ILevelGeneralDto } from 'src/app/infrastructure/models/level-general-dto';
import { IClaimRefDto } from './claim-ref-dto.g';
import { IDomainDto } from './domain-dto.g';
import { IClaimDto } from './claim-dto.g';

export const claimActionDto = {
    guid: 'guid',
    nr: 'nr',
    name: 'name',
    deleted: 'deleted',
    inactive: 'inactive',
    claimsDto: 'claimsDto',
} as const;

export type TClaimActionDto = (typeof claimActionDto)[keyof typeof claimActionDto];

export const claimActionDtoConstraints = {
    name: { required: true },
    guid: { required: true },
} as const;

export type TClaimActionDtoConstraints = typeof claimActionDtoConstraints;

export interface IClaimActionDto extends ILevelGeneralDto {
    [claimActionDto.guid]: string | null;
    [claimActionDto.nr]: number | null;
    [claimActionDto.name]: string | null;
    [claimActionDto.deleted]: boolean | null;
    [claimActionDto.inactive]: boolean | null;
    [claimActionDto.claimsDto]: IClaimRefDto[] | null;
}

export class ClaimActionDto
    implements IClaimActionDto
{
    [claimActionDto.guid]: string | null = null;
    [claimActionDto.nr]: number | null = null;
    [claimActionDto.name]: string | null = null;
    [claimActionDto.deleted]: boolean | null = null;
    [claimActionDto.inactive]: boolean | null = null;
    [claimActionDto.claimsDto]: IClaimRefDto[] | null = null;

    private constructor(
        modelData?: IClaimActionData,
    ) {
        if (!modelData || isEmptyObject(modelData)) return;

        this[claimActionDto.guid] = modelData[claimActionData.guid];
        this[claimActionDto.nr] = modelData[claimActionData.nr];
        this[claimActionDto.name] = modelData[claimActionData.name];
        this[claimActionDto.deleted] = modelData[claimActionData.deleted];
        this[claimActionDto.inactive] = modelData[claimActionData.inactive];
    }

    static create(modelData?: IClaimActionData | null): IClaimActionDto | null {
        return modelData ? new ClaimActionDto(modelData) : null;
    }
}
